import client from './index'
import store from '@/store'

const getData = (type,url, request = {}) => client[type].get(url,request)
const postData = (type,url,data, options = {}) => client[type].post(url,data, options)
const patchData = (type,url,data, options = {}) => client[type].patch(url,data, options)
const putData = (type,url,data, options = {}) => client[type].put(url,data, options)
const destroyData = (type,url,options = {}) => client[type].delete(url, options)
const uploadData = (type,url,data) => client[type].post(url, data, {"Content-Type": "multipart/form-data",  onUploadProgress: progressEvent => {
    let percentCompleted = Math.floor((progressEvent.loaded * 100) / progressEvent.total);
    store.dispatch('setUploadLoading',percentCompleted)
}})
const downloadFile = (type,url) => client[type].get(url, { responseType: 'blob'})

export {
    getData,
    postData,
    patchData,
    putData,
    destroyData,
    uploadData,
    downloadFile
}
